import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import Button from "components/button";
import {
    StyleHeader,
    LogoVw,
    StyleMenu,
    StyleMenuItem,
    StyleButtonHamburger
} from "./style";
export default ({ theme, setIsModalOpen }) => {
    const [sticky, setSticky] = useState("");
    const [showMenu, setShowMenu] = useState(false);
    
    useEffect(() => {
        console.log("hello");
        window.addEventListener("scroll", isSticky);
        return () => {
            window.removeEventListener("scroll", isSticky);
        }
    },[]);

    const isSticky = () => {
        /* Method that will fix header after a specific scrollable */
        const scrollTop = window.scrollY;
        const stickyClass = scrollTop >= 40 ? "is-sticky" : "";
        setSticky(stickyClass);
        console.log(stickyClass);
    };

    return (
        <>
            <StyleHeader theme={theme} className={sticky}>
                <div>
                    <div>
                        <Link to="/">
                            <LogoVw />
                        </Link>
                    </div>
                    <StyleMenu showMenu={showMenu}>
                        <StyleMenuItem to="/">Home</StyleMenuItem>
                        <StyleMenuItem to="/premios">Prêmios</StyleMenuItem>
                        <StyleMenuItem to="/regulamento">
                            Regulamento
                        </StyleMenuItem>
                        {/* <StyleMenuItem to="/faq">FAQ</StyleMenuItem> */}
                    </StyleMenu>
                    <div style={{ flexGrow: 1, flexBasis: 0 }}>
                        <Button
                            onClick={() => setIsModalOpen(true)}
                            className="small"
                            type="button"
                        >
                            Meu número
                        </Button>
                    </div>
                    <StyleButtonHamburger
                        onClick={() => setShowMenu(!showMenu)}
                        className={showMenu && "opened"}
                        ariaExpanded={showMenu}
                        aria-label="Menu principal"
                    >
                        <svg width="32" height="32" viewBox="0 0 100 100">
                            <path
                                className="line line1"
                                d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
                            />
                            <path className="line line2" d="M 20,50 H 80" />
                            <path
                                className="line line3"
                                d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
                            />
                        </svg>
                    </StyleButtonHamburger>
                </div>
            </StyleHeader>
        </>
    );
}
